import React from 'react';
import { ImageWithFallback } from '@/components/ui';
import { STORE_DETAILS, ASSETS } from '@/config/store';

const quickLinks = [
  { href: '#about', label: 'About' },
  { href: '#contact', label: 'Visit' },
];

export function Footer() {
  return (
    <footer className="bg-surface text-white">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 pt-12 pb-[max(1.25rem,env(safe-area-inset-bottom,0px))]">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-8">
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-11 h-11 bg-white rounded-full flex items-center justify-center p-1.5 shrink-0">
              <ImageWithFallback
                src={ASSETS.logoBlue}
                alt={`${STORE_DETAILS.name} Logo`}
                className="w-full h-full object-contain scale-110"
                fallbackContent={
                  <span className="text-ink font-bold text-[10px] text-center leading-tight">
                    BAGBAZAR
                  </span>
                }
              />
            </div>
            <div className="min-w-0">
              <p className="font-display text-lg font-bold tracking-tight truncate" role="presentation">
                Bagbazar Provision Stores
              </p>
              <p className="text-sm text-white/50">Pokhara-1, Bagbazar</p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-[15px]">
            {quickLinks.map(({ href, label }) => (
              <a
                key={href}
                href={href}
                className="text-white/65 hover:text-white transition-colors cursor-pointer"
              >
                {label}
              </a>
            ))}
            <a
              href={`tel:${STORE_DETAILS.phone.replace(/\s/g, '')}`}
              className="min-h-11 inline-flex items-center text-brand-light hover:text-white transition-colors cursor-pointer font-medium touch-manipulation"
            >
              {STORE_DETAILS.phone}
            </a>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-5 text-sm text-white/40">
          <p>
            © {new Date().getFullYear()} Bagbazar Provision Stores. Designed by{' '}
            <a
              href="https://sangamadhikari.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-light/90 hover:text-white transition-colors"
            >
              Sangam Adhikari
            </a>
            {' · '}
            <a
              href="https://sawongam.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-light/90 hover:text-white transition-colors"
            >
              sawongam
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
